<template>
    <div class='container outbox'>
       <div class='header'>
        <div class='title'>发件箱</div>
        <div class='search'>
            <el-input size='small' placeholder="搜索消息主题" v-model="content">
            <el-button slot="append" type="success" @click="getList(content)">搜索</el-button>
            </el-input>
        </div>
       </div>
       <div class='section'>
           <div class='message_list_item head'>
            <span class='theme'>消息主题</span>
            <span class='recipients'>收件人</span>
            <span class='delivery_date'>发送日期</span>
            <span class='accessory'>附件</span>
             <span class='status'>已读/未读</span>
             <span class='action'>操作</span>
           </div>
           <div v-for='(item,index) in boxList' :key='index' class='message_list_item item' :class="{'isrevoke':item.status != 1}">
            <span class='theme cursor'  @click='goDetail(item.messageID,item.status)'>{{item.title}}</span>
            <span class='recipients cursor' @click='showDetailList(item.messageID,item.messageType)'>{{item.receiver}}</span>
            <span class='delivery_date' >{{item.sendTime}}</span>
            <span class='accessory'><span v-if='item.attachment != 0' style='font-size:18px;' class='fa fa-paperclip'></span></span>
             <span class='status cursor' @click='showDetailList(item.messageID,item.messageType)'>{{item.isLookNum}}/{{item.noLookNum}}</span>
             <span class='action'>
                 <button v-if='item.status == 1' type="button" @click='showDeleteDialog(item.messageID)' class="btn btn-outline btn-primary">撤回</button>
                 <span v-else>已撤回</span>
             </span>
           </div>
       </div>
       <div class='foot'>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @current-change='getChange'
                :page-size=10>
            </el-pagination>
        </div>
       <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :close-on-click-modal='false'>
            <span>确认撤回？</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="doDelete">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
        
        width="45%"
        title="接收对象详情"
        :visible.sync="isShowDetailList" :close-on-click-modal='false'>
        <div style='min-height:500px;'>
           <detail-list @download='downloadList' :tableData='tableData' :isShow='isShowDetailList' :receiverType='receiverType'></detail-list>
            <!-- <el-table :data="tableData" border style="width: 100%"   @filter-change='filterChange' >
                <el-table-column prop="num" label="序号" width="90"></el-table-column>
                <el-table-column prop="orgName" label="名称" width="130"></el-table-column>
                <el-table-column prop="name" label="姓名" width="150"></el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="150"></el-table-column>
                <el-table-column prop="regionName" label="所属区域" width="110"></el-table-column>
                <el-table-column prop="status" label="状态" :filters="[{ text: '已读', value: '已读' }, { text: '未读', value: '未读' }]"
                 :filter-method="filterTag" filter-placement="bottom-end" width="96"></el-table-column>
            </el-table> -->
            
        </div>
        </el-dialog>
    </div>
</template>

<script>
import ajax from '@/com/ajax'
import config from '@/com/config'
import detailList from '../../components/notice/detailList'

export default {
  data () {
    return {
      boxList: [],
      dialogVisible: false,
      content: '',
      total: 0,
      currentPage: 1,
      currentMsgID: 0,
      currentType: 0,
      currentStatus: 0,
      isShowDetailList: false,
      receiverType: '', // 收件人类型
      tableData: []
    }
  },
  components: {
    detailList
  },
  methods: {
    showDeleteDialog (msgID) {
      this.dialogVisible = true
      this.currentMsgID = msgID
    },
    getDetailList (id, type) {
      let self = this

      ajax.get(`${config.khsHost}infoflow/message/outbox/receivers/${id}/?subType=${type}`).then(function (res) {
        if (res && res.success) {
          let list = res.body.receiverList
          self.receiverType = res.body.receiverType
          self.tableData = []
          for (let i in list) {
            let obj = {}
            self.$set(obj, 'num', i)
            self.$set(obj, 'orgName', list[i].orgName)
            self.$set(obj, 'name', list[i].name)
            self.$set(obj, 'phone', list[i].phone)
            self.$set(obj, 'regionName', list[i].regionName)
            self.$set(obj, 'role', list[i].role)
            if (list[i].status === 0) {
              self.$set(obj, 'status', '未读')
            } else {
              self.$set(obj, 'status', '已读')
            }

            self.$set(self.tableData, i, obj)
          }
        }
      })
    },
    downloadList (payload) {
      let statusType = payload.statusType
      switch (statusType) {
        case '0':this.currentStatus = 0; break
        case '1':this.currentStatus = 1; break
        case '2':this.currentStatus = -1; break
      }
      // let self = this
      let statusUrl = ''
      if (this.currentStatus !== -1) {
        statusUrl = `&status=${this.currentStatus}`
      }
      let pageUrl = `${config.khsHost}infoflow/message/outbox/receivers/${this.currentMsgID}/export?subType=${this.currentType}${statusUrl}`

      this.downloadXls(pageUrl, undefined, '接受类型列表')
    },
    filterChange (e) {
      for (let key in e) {
        if (e[key].length === 0 || e[key].length === 2) {
          this.currentStatus = -1 // 全部
        }
      }
    },
    getList (content) {
      var self = this
      let param = {}
      this.boxList = []
      if (content !== undefined) {
        param.title = content
      }
      param.pageNum = this.currentPage
      param.pageSize = 10
      ajax.post(config.khsHost + '/infoflow/message/hhs/outbox/list', param).then(function (res) {
        if (res && res.success) {
          let list = res.body.list

          for (let i in list) {
            let obj = {}
            self.$set(obj, 'title', list[i].title)
            self.$set(obj, 'receiver', list[i].receiver)
            self.$set(obj, 'sendTime', list[i].sendTime)
            self.$set(obj, 'attachment', list[i].attachment)
            self.$set(obj, 'isLookNum', list[i].isLookNum)
            self.$set(obj, 'noLookNum', list[i].noLookNum)

            self.$set(obj, 'status', list[i].status)
            self.$set(obj, 'messageID', list[i].messageID)
            self.$set(obj, 'messageType', list[i].messageType)
            self.$set(self.boxList, i, obj)
          }
          let page = res.body.page
          self.total = page.total
        }
      })
    },
    getChange (e) {
      this.currentPage = e
      this.getList()
    },
    goDetail (id, status) {
     // if (status === 1) {
      this.$router.push({path: 'detail', query: {id: id, type: 'outbox'}})
      // }
    },
    showDetailList (id, type) {
      this.currentMsgID = id
      this.currentType = type
      this.getDetailList(id, type)

      this.isShowDetailList = true
    },
    doDelete () {
      let self = this
      ajax.post(`${config.khsHost}infoflow/message/outbox/revoke/${this.currentMsgID}`, {}).then(function (res) {
        self.dialogVisible = false
        self.getList()
      })
    },
    downloadXls (url, pojo, filename) { // 封装好的导出函数
      var xhr = new XMLHttpRequest()
      xhr.open('POST', url, true)
      xhr.responseType = 'arraybuffer'
      xhr.onload = function () {
        if (this.status === 200) {
          var type = xhr.getResponseHeader('Content-Type')
          var blob = new Blob([this.response], {
            type: type
          })
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            filename += '.xls'
            window.navigator.msSaveBlob(blob, filename)
          } else {
            var URL = window.URL || window.webkitURL
            var downloadUrl = URL.createObjectURL(blob)
            if (filename) {
                            // use HTML5 a[download] attribute to specify filename
              var a = document.createElement('a')
                            // safari doesn't support this yet
              if (typeof a.download === 'undefined') {
                window.location = downloadUrl
              } else {
                a.href = downloadUrl
                a.download = filename + '.xls'
                document.body.appendChild(a)
                a.click()
              }
            } else {
              window.location = downloadUrl
            }
            setTimeout(function () {
              URL.revokeObjectURL(downloadUrl)
            },
            100) // cleanup
          }
        }
      }
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.setRequestHeader('Haiziguo-Token', localStorage.getItem('Haiziguo-Token'))
      xhr.send(pojo)
    },
    filterTag (value, row) {
      if (value === '已读') {
        this.currentStatus = 0
      } else {
        this.currentStatus = 1
      }
      return row.status === value
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
.container.outbox{
    width:100%;
    height:900px;
    background-color: #ffffff;
    display: block;
    padding:0px;
}
.outbox .header{
    display: flex;
    justify-content: space-between;
}
.outbox .title{
    font-size:20px;
    padding-top:30px;
    padding-left:30px;
}
.outbox .search{
    padding-top:30px;
    padding-right:20px;
}
.outbox .section{
    margin-top:50px;
    width: 100%;
    height: 700px;
    
    overflow-y:scroll;
}
.message_list_item{
    padding-left:5%;
    min-height:60px;
    font-weight: 900;
    display: flex;
    align-items:center;
}
.message_list_item.head{
    background-color: #F5F5F5
}
.message_list_item.item{
    border-bottom:1px solid #F5F5F5
}
.message_list_item .theme{
    display: inline-block;
    overflow-x: hidden;
    width:20%;
}
.message_list_item .recipients{
    display: inline-block;
    padding-left:10px;
    width:20%;
}
.message_list_item .delivery_date{
    display: inline-block;
    width:15%;
}
.message_list_item .accessory{
    display: inline-block;
    width:15%;
}
.message_list_item .status{
    display: inline-block;
    width:15%;
}
.message_list_item .action{
    display: inline-block;
    width:10%;
}
.message_list_item.item.isrevoke{
    color:#ddd;
}
.outbox .foot{
    position: relative;
    top:10px;
    text-align: center;
}
.cancel{
    font-size: 16px;
}
.cursor{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/outbox.vue?8c05baa6